import { render, staticRenderFns } from "./bizConfigAdd.vue?vue&type=template&id=2015b44c"
import script from "./bizConfigAdd.vue?vue&type=script&lang=js"
export * from "./bizConfigAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports